import { AddressCopyButton } from "~/components/Components/AddressCopyButton/AddressCopyButton";
import { CountryFlag } from "~/components/Components/CountryFlag/CountryFlag";
import { FormProfileImageUpload } from "~/components/Components/FormProfileImageUpload/FormProfileImageUpload";
import { AlertModal } from "~/components/Components/AlertModal/AlertModal";

type Props = {
  imageUrl: string;
  nickname: string;
  countryName: string;
  addressCopyButtonProps: React.ComponentProps<typeof AddressCopyButton>;
  changeProfileImageFormProps: React.ComponentProps<
    typeof FormProfileImageUpload
  >;
  changeProfileImageModalProps: React.ComponentProps<typeof AlertModal>;
};

export const MyPageUserProfileModule = (props: Props) => {
  return (
    <div className="flex w-full flex-col items-center gap-[16px] p-[20px] pt-0">
      <div className="relative h-[100px] w-[100px]  border-[#0000000F] bg-opacity-0">
        <FormProfileImageUpload {...props.changeProfileImageFormProps} />
      </div>
      <div className="flex flex-col items-center justify-center gap-[6px] self-stretch">
        <p className="text-[24px] font-extrabold leading-[29px]">
          {props.nickname}
        </p>
        <div className="flex items-center justify-center gap-[6px] self-stretch">
          <CountryFlag countryName={props.countryName} width={20} />
          <p className="text-[13px] font-bold leading-[16px]">
            {props.countryName.toUpperCase()}
          </p>
        </div>
      </div>
      <AddressCopyButton {...props.addressCopyButtonProps} />
      <AlertModal {...props.changeProfileImageModalProps} />
    </div>
  );
};
